import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css'
import { 
    Button, 
    Select,
    Input,
    Menu,
    MenuItem,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Dialog,
    Form,
    FormItem,
    MessageBox,
    Message,
    Notification,
    Switch,
    Carousel,
    CarouselItem,
    Avatar,
    Loading,
    Option,
    Empty
} from 'element-ui';

Vue.use(Button);
Vue.use(Select);
Vue.use(Input);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Dialog);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Switch);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Avatar);
Vue.use(Loading.directive);
Vue.use(Option);
Vue.use(Empty);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = Message;
Vue.prototype.$notify = Notification;
Vue.prototype.$confirm = MessageBox.confirm;
